/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS201: Simplify complex destructure assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const User = require('../user/user');
const ReservingTrip = require('../trip/reserving_trip').default;
const { ExicCard } = require('../exic_card');
const { toDomesticTel } = require('../../util/string');
const TravelerShinkansenType = require('./traveler_shinkansen_type').default;

class Traveler extends User {
  constructor(args) {
    let flightTel;
    if (args == null) {
      args = {};
    }
    super(args);
    this.user_id = args.user_id || '';
    this.reservingTrip = args.reservingTrip || new ReservingTrip();
    this.firstNameRoman = args.firstNameRoman || args.first_name_roman || '';
    this.lastNameRoman = args.lastNameRoman || args.last_name_roman || '';
    this.middleNameRoman = args.middleNameRoman || args.middle_name_roman || '';
    this.firstNameKana = args.firstNameKana || args.first_name_kana || '';
    this.lastNameKana = args.lastNameKana || args.last_name_kana || '';
    this.flightFirstNameKana = args.flightFirstNameKana || this.firstNameKana || '';
    this.flightLastNameKana = args.flightLastNameKana || this.lastNameKana || '';
    this.flightFirstNameRoman = args.flightFirstNameRoman || this.firstNameRoman || '';
    this.flightLastNameRoman = args.flightLastNameRoman || this.lastNameRoman || '';
    this.flightMiddleNameRoman = args.flightMiddleNameRoman || this.middleNameRoman || '';
    this.flightBirthday = args.flightBirthday || args.birthday || args.flight_birthday || '';
    this.flightGender = args.flightGender || args.gender || args.flight_gender || 'male';
    const travelerInformations = args.traveler_informations || [];
    const searchQueryId = args.search_query_id || 0;
    const info =
      args.info || travelerInformations.find(information => information.search_query_id === searchQueryId);
    this.travelerInformationId = dig(info, 'id');
    this.airSeat = ''; // 航空券は常に座席希望をクリア
    this.shinkansenTicketType = args.shinkansenTicketType || args.shinkansen_ticket_type || undefined;
    this.shinkansenSeatType = args.shinkansenSeatType || args.shinkansen_seat_type || undefined;
    this.shinkansenSeatDetail = args.shinkansenSeat || args.shinkansen_seat || '';
    this.shinkansenSeat = this.shinkansenSeatDetail.split(/\r\n|\r|\n/)[0] || '';
    if (!Array.isArray(args.travelerInformationShinkansenTypes)) {
      if (args.traveler_information_shinkansen_types) {
        this.travelerInformationShinkansenTypes = args.traveler_information_shinkansen_types.map(
          type =>
            new TravelerShinkansenType(TravelerShinkansenType.convertTravelerShinkansenTypeResponseToArgs(type))
        );
      } else {
        this.travelerInformationShinkansenTypes = [];
      }
    }
    this.requestShinkansenSeat = '';
    this.mileageNumber = args.mileageNumber || dig(info, 'mileage_number') || '';
    this.mileageNumbers = args.mileageNumbers || dig(info, 'mileage_numbers') || [];
    if (this.mileageNumbers && !Array.isArray(this.mileageNumbers)) {
      this.mileageNumbers = Object.values(this.mileageNumbers);
    }
    this.exicNumber = args.exicNumber || args.exic_number || args.exicId || args.exic_id || '';
    this.exicPassword = args.exicPassword || args.exic_password || '';
    if (args.exic_card) {
      this.exicCard = new ExicCard(args.exic_card);
    }
    this.exicCardId = args.exicCardId || args.exic_card_id;
    this.passportNumber = args.passportNumber || dig(info, 'passport_number') || '';
    this.passportExpire = args.passportExpire || dig(info, 'passport_expire') || '';
    this.passportIssuedCoutry = args.passportIssuedCoutry || dig(info, 'passport_issued_country') || '日本';
    this.type = args.type || 'self';
    if (args.type === 'member') {
      flightTel = dig(info, 'flight_tel');
      this.flightTel = flightTel || args.tel || '';
    } else {
      this.flightTel = args.flightTel || args.flight_tel || args.tel || '';
    }
    const flightFirstName = dig(info, 'flight_first_name') || '';
    const flightLastName = dig(info, 'flight_last_name') || '';
    const flightMiddleName = dig(info, 'flight_middle_name') || '';
    if (flightFirstName.match(/[A-za-z]+/) && flightLastName.match(/[A-za-z]+/)) {
      if (!this.flightFirstNameRoman) {
        this.flightFirstNameRoman = flightFirstName || '';
      }
      if (!this.flightLastNameRoman) {
        this.flightLastNameRoman = flightLastName || '';
      }
      if (!this.flightMiddleNameRoman) {
        this.flightMiddleNameRoman = flightMiddleName || '';
      }
    } else if (flightFirstName.match(/^[ァ-ヶー　]*$/) && flightLastName.match(/^[ァ-ヶー　]*$/)) {
      if (!this.flightFirstNameKana) {
        this.flightFirstNameKana = flightFirstName || '';
      }
      if (!this.flightLastNameKana) {
        this.flightLastNameKana = flightLastName || '';
      }
    }

    this.immigrationCardCreation = false;
    this.visaApplication = false;
    this.prefectureId = dig(info, 'prefecture_id') || 0;
    this.organization = args.organization || undefined;
    this.department = _.merge(args.department, { id: args.department_id });
    this.gradeId = args.grade_id ? parseInt(args.grade_id) : undefined;
    this.nationalityId = dig(info, 'nationality_id') || args.nationality_id || 121; // デフォルトは日本
    this.displayName = args.display_name;
    this.domesticAirSeatUpgrade = args.domestic_air_seat_upgrade;
  }

  getTravelerName() {
    return this.name || `${this.lastNameRoman} ${this.firstNameRoman}`;
  }

  isTravelerShinkansenType(elementIndex = null) {
    return (
      this.shinkansenTicketType !== undefined ||
      this.shinkansenSeatType !== undefined ||
      (elementIndex !== null &&
        this.travelerInformationShinkansenTypes &&
        this.travelerInformationShinkansenTypes.length > 0 &&
        this.travelerInformationShinkansenTypes[elementIndex])
    );
  }

  getShinkansenTicketTypeText(elementIndex = null) {
    if (
      elementIndex !== null &&
      this.travelerInformationShinkansenTypes &&
      this.travelerInformationShinkansenTypes[elementIndex]
    ) {
      const type = this.travelerInformationShinkansenTypes[elementIndex];
      if (type.shinkansenTicketType) {
        return type.getShinkansenTicketTypeText();
      }
    }

    switch (this.shinkansenTicketType) {
      case 'normal':
        return '通常きっぷ';
      case 'kyuusyuu':
        return 'JR九州きっぷ';
      case 'bulk_ticket':
        return '回数券';
      case 'ex':
        return 'EX-IC';
    }
  }

  getShinkansenSeatTypeText(elementIndex = null) {
    if (
      elementIndex !== null &&
      this.travelerInformationShinkansenTypes &&
      this.travelerInformationShinkansenTypes[elementIndex]
    ) {
      const type = this.travelerInformationShinkansenTypes[elementIndex];
      if (type.shinkansenSeatType) {
        return type.getShinkansenSeatTypeText();
      }
    }

    switch (this.shinkansenSeatType) {
      case 'reserve':
        return '指定席';
      case 'free':
      case 'non_reserved':
        return '自由席';
      case 'green':
        return 'グリーン席';
    }
  }

  getTravelerShinkansenType(elementIndex = null) {
    let shinkansenSeat;
    const list = [];
    const shinkansenTicketType = this.getShinkansenTicketTypeText(elementIndex);
    const shinkansenSeatType = this.getShinkansenSeatTypeText(elementIndex);
    if (shinkansenSeatType !== '自由席') {
      ({ shinkansenSeat } = this);
    }

    if (shinkansenTicketType) {
      list.push(`券種: ${shinkansenTicketType}`);
    }
    if (shinkansenSeatType) {
      list.push(`座席: ${shinkansenSeatType}`);
    }
    if (shinkansenSeat) {
      list.push(`座席希望: ${shinkansenSeat}`);
    }

    // 条件判定が複雑なため、最終的なラベルで判定
    if (shinkansenTicketType === 'EX-IC') {
      // @shinkansenTicketType == 'ex'
      if (this.exicNumber) {
        list.push(`EXIC会員ID: ${this.exicNumber}`);
      }
      if (this.exicPassword) {
        list.push(`EXICパスワード: ${this.exicPassword.replace(/./g, '*')}`);
      }
    }

    return `(${this.getTravelerName()}) ${list.join(', ')}`;
  }

  getTravelerAirlineTypeForeign() {
    const list = [];
    if (this.airSeat) {
      list.push(`座席希望: ${this.airSeat}`);
    }
    if (this.mileageNumber || this.mileageNumbers.length > 0) {
      list.push(`マイル番号: ${this.getTravelerMileageNumberForeign()}`);
    }
    return `(${this.getTravelerName()}) ${list.join(', ')}`;
  }

  getTravelerAirlineTypeDomestic() {
    const list = [];
    if (this.airSeat) {
      list.push(`座席希望: ${this.airSeat}`);
    }
    if ((this.mileageNumber && !this.userId) || this.mileageNumbers.length > 0) {
      list.push(`マイル番号: ${this.getTravelerMileageNumberDomestic()}`);
    }
    return `(${this.getTravelerName()}) ${list.join(', ')}`;
  }

  getTravelerMileageNumberForeign() {
    const list = [];
    if (this.mileageNumber) {
      list.push(this.mileageNumber);
    }
    if (this.mileageNumbers != null) {
      this.mileageNumbers.forEach(mileageNumber =>
        list.push(`(${mileageNumber.carrier}) ${mileageNumber.number}`)
      );
    }
    return list.join('、');
  }

  getTravelerMileageNumberDomestic() {
    const list = [];
    // 社員マスタから選択した(userIdを持っている)場合、mileageNumber(手入力)は表示しない
    if (this.mileageNumber && !this.userId) {
      list.push(this.mileageNumber);
    }
    if (this.mileageNumbers != null) {
      this.mileageNumbers.forEach(mileageNumber =>
        list.push(`(${mileageNumber.carrier}) ${mileageNumber.number}`)
      );
    }
    return list.join('、');
  }

  getTravelerNameFromPriority() {
    if (this.lastName && this.firstName) {
      return `${this.lastName} ${this.firstName}`;
    } else if (this.lastNameKana && this.firstNameKana) {
      return `${this.lastNameKana} ${this.firstNameKana}`;
    } else {
      return `${this.lastNameRoman} ${this.firstNameRoman}`;
    }
  }

  getTravelerParams(reservingTrip) {
    if (reservingTrip == null) {
      reservingTrip = {};
    }
    return {
      user_id: this.user_id || (this.type === 'companion' ? '' : this.id),
      type: this.type,
      first_name: this.firstName,
      last_name: this.lastName,
      first_name_kana: this.firstNameKana,
      last_name_kana: this.lastNameKana,
      first_name_roman: this.firstNameRoman,
      last_name_roman: this.lastNameRoman,
      birthday: this.birthday,
      tel: this.tel,
      air_seat: this.airSeat,
      shinkansen_ticket_type: this.shinkansenTicketType,
      shinkansen_seat_type: this.shinkansenSeatType,
      shinkansen_seat: this.requestShinkansenSeat
        ? `${this.shinkansenSeat}:${this.requestShinkansenSeat}`
        : this.shinkansenSeat,
      mileage_number: this.mileageNumber,
      exic_number: this.exicNumber,
      exic_password: this.exicPassword,
      exic_card_id: this.exicCardId,
      flight_first_name: dig(reservingTrip, 'isForeignFlightCustomerInfoRequired')
        ? this.flightFirstNameRoman
        : this.flightFirstNameKana,
      flight_last_name: dig(reservingTrip, 'isForeignFlightCustomerInfoRequired')
        ? this.flightLastNameRoman
        : this.flightLastNameKana,
      flight_middle_name: dig(reservingTrip, 'isForeignFlightCustomerInfoRequired')
        ? this.flightMiddleNameRoman
        : '',
      flight_first_name_kana: this.flightFirstNameKana,
      flight_last_name_kana: this.flightLastNameKana,
      flight_first_name_roman: this.flightFirstNameRoman,
      flight_last_name_roman: this.flightLastNameRoman,
      flight_middle_name_roman: this.flightMiddleNameRoman,
      flight_birthday: this.flightBirthday,
      flight_gender: this.flightGender,
      flight_tel: this.flightTel ? toDomesticTel(this.flightTel.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '')) : '',
      passport_number: this.passportNumber,
      passport_expire: this.passportExpire,
      passport_issued_country: this.passportIssuedCoutry,
      immigration_card_creation: this.immigrationCardCreation,
      visa_application: this.visaApplication,
      prefecture_id: this.prefectureId,
      nationality_id: this.nationalityId,
      traveler_information_id: this.travelerInformationId
    };
  }

  getQueryString(key) {
    let res = '';
    _.entries(this.getTravelerParams()).forEach(function (...args) {
      const [k, v] = Array.from(args[0]);
      if (_.isNil(v) || v === '') {
        return;
      }
      return (res += `${key}[${k}]=${v}&`);
    });
    return res;
  }

  setReservingTrip(value) {
    this.reservingTrip = value;
    if (this.reservingTrip.isShinkansenInfoRequired() && this.shinkansenSeatType === undefined) {
      return this.setInitialShinkansenTypes();
    }
  }

  setFirstNameRoman(value) {
    this.firstNameRoman = value;
    this.flightFirstNameRoman = value;
    return app.render();
  }

  setLastNameRoman(value) {
    this.lastNameRoman = value;
    this.flightLastNameRoman = value;
    return app.render();
  }

  setFirstNameKana(value) {
    this.firstNameKana = value;
    this.flightFirstNameKana = value;
    return app.render();
  }

  setLastNameKana(value) {
    this.lastNameKana = value;
    this.flightLastNameKana = value;
    return app.render();
  }

  setBirthday(value) {
    this.birthday = value;
    this.flightBirthday = value;
    return app.render();
  }

  setFlightFirstNameRoman(value) {
    this.flightFirstNameRoman = value;
    return app.render();
  }

  setFlightLastNameRoman(value) {
    this.flightLastNameRoman = value;
    return app.render();
  }

  setFlightMiddleNameRoman(value) {
    this.flightMiddleNameRoman = value;
    return app.render();
  }

  setFlightFirstNameKana(value) {
    this.flightFirstNameKana = value;
    return app.render();
  }

  setFlightLastNameKana(value) {
    this.flightLastNameKana = value;
    return app.render();
  }

  setFlightGender(value) {
    this.flightGender = value;
    return app.render();
  }

  setFlightBirthday(value) {
    this.flightBirthday = value;
    this.birthday = value;
    return app.render();
  }

  setFlightTel(value) {
    this.flightTel = value;
    return app.render();
  }

  setAirSeat(value) {
    this.airSeat = value;
    return app.render();
  }

  setShinkansenTicketType(value) {
    this.shinkansenTicketType = value;
    return app.render();
  }

  setInitialShinkansenTypes() {
    if (!this.shinkansenTicketType) {
      this.shinkansenTicketType = 'normal';
    }
    if (!this.shinkansenSeat) {
      this.shinkansenSeat = '指定なし';
    }
    let seatType = this.reservingTrip.isUnreservedSeatAvailable || !this.organization ? 'free' : undefined;
    if (this.organization) {
      const SeatTypes = ['free', 'reserve', 'green'];
      const { gradeId } = this; // 一旦代入しないと何故かfilterの一致が取れませんでした。。
      const Grade = _.first(
        this.organization.grades != null ? this.organization.grades.filter(g => g.id === gradeId) : undefined
      );
      let targetSeatTypes = __guard__(Grade != null ? Grade.shinkansen_seat_type : undefined, x => x.split(','));
      targetSeatTypes =
        targetSeatTypes != null ? targetSeatTypes.filter(seatType => SeatTypes.includes(seatType)) : undefined;

      if (targetSeatTypes && targetSeatTypes.length) {
        if (targetSeatTypes.includes('reserve')) {
          seatType = 'reserve';
        } else {
          if (targetSeatTypes.includes('free') && this.reservingTrip.isUnreservedSeatAvailable) {
            seatType = 'free';
          } else {
            seatType = 'green';
          }
        }
      }
    }

    return (this.shinkansenSeatType = seatType);
  }

  setShinkansenSeatType(value) {
    this.shinkansenSeatType = value;
    return app.render();
  }

  setShinkansenSeatText(value) {
    this.requestShinkansenSeat = value;
    this.shinkansenSeatText = `${this.shinkansenSeat}\n${this.requestShinkansenSeat}`;
    return app.render();
  }

  setShinkansenSeat(value) {
    if (value !== 'その他') {
      this.requestShinkansenSeat = '';
    } else {
    }
    this.shinkansenSeat = value;
    this.shinkansenSeatText = value;
    return app.render();
  }

  setMileageNumber(value) {
    this.mileageNumber = value;
    return app.render();
  }

  setExicNumber(value) {
    this.exicNumber = value;
    return app.render();
  }

  setExicPassword(value) {
    this.exicPassword = value;
    return app.render();
  }

  setExicCardId(value) {
    this.exicCardId = value;
    return app.render();
  }

  setPassportNumber(value) {
    this.passportNumber = value;
    return app.render();
  }

  setPassportExpire(value) {
    this.passportExpire = value;
    return app.render();
  }

  setPassportIssuedCountry(value) {
    this.passportIssuedCoutry = value;
    return app.render();
  }

  setImmigrationCardCreation(value) {
    this.immigrationCardCreation = value === 'true';
    return app.render();
  }

  setVisaApplication(value) {
    this.visaApplication = value === 'true';
    return app.render();
  }

  setPrefectureId(value) {
    this.prefectureId = parseInt(value, 10);
    return app.render();
  }

  setNationalityId(value) {
    this.nationalityId = value;
    return app.render();
  }

  validate(errors, isForeignFlightCustomerInfoRequired) {
    switch (this.type) {
      case 'self':
        if (!this.id) {
          return (errors.memberSelect = '出張者を選択してください');
        }
        break;
      case 'member':
        if (!this.id) {
          return (errors.memberSelect = '出張者を選択してください');
        }
        break;
      case 'companion':
        if (isForeignFlightCustomerInfoRequired) {
          if (_.isEmpty(errors.travelerFirstNameRomen) && _.isEmpty(errors.travelerLastNameRomen)) {
            errors.travelerFirstNameRomen = this.requiredError('出張者の名前(ローマ字)', this.firstNameRoman);
            errors.travelerLastNameRomen = this.requiredError('出張者の名字(ローマ字)', this.lastNameRoman);
          }
          if (_.isEmpty(errors.travelerFirstNameKana) && _.isEmpty(errors.travelerLastNameKana)) {
            errors.travelerFirstNameKana = this.requiredError('出張者の名前(カナ)', this.firstNameKana);
            errors.travelerLastNameKana = this.requiredError('出張者の名字(カナ)', this.lastNameKana);
          }
          if (_.isEmpty(errors.travelerFirstNameRomen) && _.isEmpty(errors.travelerLastNameRomen)) {
            errors.travelerFirstNameRomen = this.alphabetError('出張者の名前(ローマ字)', this.firstNameRoman);
            errors.travelerLastNameRomen = this.alphabetError('出張者の名字(ローマ字)', this.lastNameRoman);
          }
          if (_.isEmpty(errors.travelerFirstNameKana) && _.isEmpty(errors.travelerLastNameKana)) {
            errors.travelerFirstNameKana = this.katakanaError('出張者の名前(カナ)', this.firstNameKana);
            return (errors.travelerLastNameKana = this.katakanaError('出張者の名字(カナ)', this.lastNameKana));
          }
        } else {
          if (_.isEmpty(errors.travelerFirstNameRomen) && _.isEmpty(errors.travelerLastNameRomen)) {
            errors.travelerFirstNameRomen = this.requiredError('出張者の名前(ローマ字)', this.firstNameRoman);
            errors.travelerLastNameRomen = this.requiredError('出張者の名字(ローマ字)', this.lastNameRoman);
          }
          if (_.isEmpty(errors.travelerFirstNameKana) && _.isEmpty(errors.travelerLastNameKana)) {
            errors.travelerFirstNameKana = this.requiredError('出張者の名前(カナ)', this.firstNameKana);
            errors.travelerLastNameKana = this.requiredError('出張者の名字(カナ)', this.lastNameKana);
          }
          if (_.isEmpty(errors.travelerFirstNameRomen) && _.isEmpty(errors.travelerLastNameRomen)) {
            errors.travelerFirstNameRomen = this.alphabetError('出張者の名前(ローマ字)', this.firstNameRoman);
            errors.travelerLastNameRomen = this.alphabetError('出張者の名字(ローマ字)', this.lastNameRoman);
          }
          if (_.isEmpty(errors.travelerFirstNameKana) && _.isEmpty(errors.travelerLastNameKana)) {
            errors.travelerFirstNameKana = this.katakanaError('出張者の名前(カナ)', this.firstNameKana);
            errors.travelerLastNameKana = this.katakanaError('出張者の名字(カナ)', this.lastNameKana);
          }
          if (_.isEmpty(errors.travelerFirstNameKana) && _.isEmpty(errors.travelerLastNameKana)) {
            return (errors.travelerFirstName =
              this.katakanaError('搭乗者氏名', this.flightLastNameKana) ||
              this.katakanaError('搭乗者氏名', this.flightFirstNameKana));
          }
        }
        break;
    }
  }

  flightValidate(errors, isForeignFlightCustomerInfoRequired) {
    if (isForeignFlightCustomerInfoRequired) {
      errors.flightCustomerName =
        this.alphabetError('搭乗者氏名', this.flightLastNameRoman) ||
        this.alphabetError('搭乗者氏名', this.flightFirstNameRoman) ||
        this.alphabetErrorAllowEmpty('搭乗者氏名', this.flightMiddleNameRoman);
    } else {
      errors.flightCustomerName =
        this.requiredError('搭乗者氏名', this.flightLastNameKana) ||
        this.requiredError('搭乗者氏名', this.flightFirstNameKana);
      if (_.isEmpty(errors.flightCustomerName)) {
        errors.flightCustomerName =
          this.katakanaError('搭乗者氏名', this.flightLastNameKana) ||
          this.katakanaError('搭乗者氏名', this.flightFirstNameKana);
      }
    }
    if (this.type === 'companion') {
      errors.travelerBirthday = this.dateError('出張者の誕生日', this.flightBirthday);
    }
    errors.flightCustomerBirthday = this.dateError('搭乗者の誕生日', this.flightBirthday);
    errors.flightCustomerTel = this.requiredError('搭乗者の緊急連絡先', toDomesticTel(this.flightTel));
    if (isForeignFlightCustomerInfoRequired) {
      errors.passportNumber = this.requiredError('パスポート番号', this.passportNumber);
      errors.passportExpire = this.requiredError('パスポート有効期限', this.passportExpire);
      errors.passportIssuedCoutry = this.requiredError('パスポート発行国', this.passportIssuedCoutry);
    }
    return (errors.flightCustomerGender = this.requiredError('性別', this.flightGender, 'を選択してください'));
  }

  requiredError(name, value) {
    if (!value || value.length === 0) {
      return name + 'を入力してください';
    } else {
      return undefined;
    }
  }

  katakanaError(name, value) {
    if (!value.match(/^[ァ-ヶー　]*$/)) {
      return name + 'はカタカナで入力してください';
    } else {
      return undefined;
    }
  }

  alphabetError(name, value) {
    const error = this.requiredError(name, value);
    if (error) {
      return error;
    } else if (!value.match(/^[a-zA-Z]+$/)) {
      return name + 'はアルファベッドで入力してください';
    } else {
      return undefined;
    }
  }

  alphabetErrorAllowEmpty(name, value) {
    if (!value || value.length === 0) {
      return undefined;
    } else if (!value.match(/^[a-zA-Z]+$/)) {
      return name + 'はアルファベッドで入力してください';
    } else {
      return undefined;
    }
  }

  dateError(name, value) {
    const error = this.requiredError(name, value);
    if (error) {
      return error;
    } else if (!moment(value).isValid()) {
      return name + 'を正しく入力してください（例：1986-01-01）';
    } else {
      return undefined;
    }
  }
}

module.exports = Traveler;

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
